module.exports = __webpack_public_path__ + "img/video_screen.df15e547.png";